import { render, staticRenderFns } from "./tableOffers.vue?vue&type=template&id=9a481d86&scoped=true"
import script from "./tableOffers.vue?vue&type=script&lang=js"
export * from "./tableOffers.vue?vue&type=script&lang=js"
import style0 from "./tableOffers.vue?vue&type=style&index=0&id=9a481d86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a481d86",
  null
  
)

export default component.exports